import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import { theme } from 'styles/theme/hav-theme'
import { Typography } from 'components'

const growUp = keyframes`
  from{
    margin: 0 0;
    transform: scale(0);
  }

  to {
    transform: scale(1);
    margin: ${theme.spacing.xm} 0;
  }
`

export const ErrorWrapper = styled.div`
  animation: ${growUp} 0.3s ease-out;
  margin: ${theme.spacing.xm} 0;
`

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.lg};
`

export const FieldsWrapper = styled.div``

export const ResetPasswordContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: -${theme.spacing.md} 0 ${theme.spacing.xs};
`
export const LinkToResetPassword = styled.a`
  max-width: fit-content;
  font-size: ${theme.typography.sizes.xs};
  font-weight: ${theme.typography.weight.md};
  color: ${theme.colors.primary.main};
`

export const AlertLink = styled.span`
  cursor: pointer;
  color: ${theme.colors.neutral.black};
  font-family: ${theme.typography.family.bold};
  text-decoration: underline;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 524px;
  align-items: center;
`
export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 12px;
  margin-block: 40px;
`

export const Title = styled(Typography)`
  color: ${theme.colors.primary.main} !important;
`

export const Subtitle = styled(Typography)`
  margin-top: 16px;
`
